export default "__VITE_ASSET__C_dU_xXF__"